//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import MaterialTable from "material-table";

import { Row, Col } from "reactstrap";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import HeaderStepCampanha from './HeaderStepCampanha';
// services
import { formateDate } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import {table_translate} from "beaktShared/constants/TableTranslate";

const useStyles = makeStyles(styles);

export default function VisualizacaoCampanha({ item, handleProximoStep, handleStepAnterior, disabledform }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const { register, handleSubmit, getValues, setValue, clearError, setError, errors } = useForm({ mode: "onChange" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 4000);
    };

    const [clientes, set_clientes] = React.useState([]);
    const [selectedList, set_selectedList] = React.useState([]);
    const [ObsDescartado, set_ObsDescartado] = React.useState("");

    useEffect(() => {
        if (disabledform) {
            set_ObsDescartado("Clientes selecionados foram descartados da campanha!")
        }
        else {
            set_ObsDescartado("Ao selecionar um cliente ele será descartado da campanha!")

        }

        let _clientes = item.clientesExibicao;
        _clientes.map(m => {
            if (m.descartado) m.tableData = { checked: true };
        });
        set_clientes(_clientes);
        set_selectedList(item.clientesExibicao.filter(f => f.descartado == true));
    }, [item]);

    //colunas Table e Ações
    const columnsProp = [
        { title: t('label.name'), field: "nome" },
        { title: t('label.date_of_birth'), field: "dataNascimento", render: (rowData) => rowData.dataNascimento == null ? "" : formateDate(rowData.dataNascimento) },
        { title: t('label.neighborhood'), field: "bairro" },
        { title: t('label.city'), field: "cidade" },
        { title: t('label.last_review'), field: "dataUltimaAvaliacao", render: (rowData) => rowData.dataUltimaAvaliacao == null ? "" : formateDate(rowData.dataUltimaAvaliacao) },
        { title: t('label.last_appointment'), field: "dataUltimoAgendamento", render: (rowData) => rowData.dataUltimoAgendamento == null ? "" : formateDate(rowData.dataUltimoAgendamento) },
        { title: t('label.last_sale'), field: "dataUltimaVenda", render: (rowData) => rowData.dataUltimaVenda == null ? "" : formateDate(rowData.dataUltimaVenda) },
        { title: t('label.average_ticket'), field: "ticketMedio", render: (rowData) => "R$ " + Math.abs(rowData.ticketMedio).toFixed(2).replace('.', ',') },
        { title: t('label.profession'), field: "profissaoDescricao"},

    ]

    //voltar step Identificacaocampanha 
    const handleReturnForm = () => {
        handleStepAnterior(item);
    };
    //Próximo step ConclusaoCampanha
    const handleProximoStepForm = () => {
        let _clientes = item.clientesExibicao;
        // se disableForm for = true é porque essa tela será visualzada pelo acompanhamento e com isso não pdoerá validar a coluna de
        console.log(selectedList);
        if (!disabledform) {
            if (_clientes.length == selectedList.length) {
                showNotification("A campanha precisa ter pelomenos 1 cliente!", 'info');
                return;
            }

            _clientes.map(m => {
                if (selectedList.filter(f => f.clienteId == m.clienteId).length > 0)
                    m.descartado = true;
                else
                    m.descartado = false;
            });
        }

        let _item = item;
        _item.clientesExibicao = _clientes;
        handleProximoStep(_item);
    }
    return (

        <div>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />
            <HeaderStepCampanha etapa={1}></HeaderStepCampanha>

            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardBody>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            icon={<Check className={classes.uncheckedIcon} />}
                                            color={"info"}
                                            disabled={true}
                                        />
                                    }
                                    label={ObsDescartado}
                                />
                            </GridItem>
                            <Row>
                                <Col md="12" className="mt-1 mb-4">
                                    <MaterialTable
                                        title="Clientes encontrados"
                                        columns={columnsProp}
                                        data={clientes}
                                        options={{
                                            selection: true,
                                            selectionProps: rowData => ({
                                                disabled: disabledform,
                                                color: 'primary'
                                            }),
                                        }}
                                        onSelectionChange={(rows) => set_selectedList(rows)}
                                        localization={table_translate}
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    <Button onClick={() => handleReturnForm()} color="transparent" className={classes.updateProfileButton}>
                        {t('label.return')}
                    </Button>
                    <Button onClick={() => handleProximoStepForm()} color="primary" className={classes.updateProfileButton}>
                        {t('button.next')}
                    </Button>
                </GridItem>
            </GridContainer>
        </div>
    );
}